import { TFunction } from 'i18next';

import { GridLocaleText } from '@mui/x-data-grid-pro';

export const getLocaleText = (t: TFunction): Partial<GridLocaleText> => ({
  toolbarQuickFilterLabel: t('toolbarQuickFilterLabel'),
  toolbarQuickFilterPlaceholder: t('toolbarQuickFilterPlaceholder'),
  toolbarFiltersTooltipHide: t('toolbarFiltersTooltipHide'),
  toolbarFiltersTooltipShow: t('toolbarFiltersTooltipShow'),
  filterPanelAddFilter: t('filterPanelAddFilter'),
  filterPanelRemoveAll: t('filterPanelRemoveAll'),
  filterPanelOperator: t('filterPanelOperator'),
  filterPanelOperatorAnd: t('filterPanelOperatorAnd'),
  filterPanelOperatorOr: t('filterPanelOperatorOr'),
  filterPanelColumns: t('filterPanelColumns'),
  filterPanelInputLabel: t('filterPanelInputLabel'),
  filterPanelInputPlaceholder: t('filterPanelInputPlaceholder'),
  toolbarColumns: t('toolbarColumns'),
  columnsPanelTextFieldLabel: t('columnsPanelTextFieldLabel'),
  columnsPanelTextFieldPlaceholder: t('columnsPanelTextFieldPlaceholder'),
  columnsPanelShowAllButton: t('columnsPanelShowAllButton'),
  columnsPanelHideAllButton: t('columnsPanelHideAllButton'),
  toolbarDensity: t('toolbarDensity'),
  toolbarDensityCompact: t('toolbarDensityCompact'),
  toolbarDensityStandard: t('toolbarDensityStandard'),
  toolbarDensityComfortable: t('toolbarDensityComfortable'),
  toolbarExport: t('toolbarExport'),
  toolbarExportCSV: t('toolbarExportCSV'),
  toolbarExportPrint: t('toolbarExportPrint'),
  columnMenuSortAsc: t('columnMenuSortAsc'),
  columnMenuSortDesc: t('columnMenuSortDesc'),
  columnMenuHideColumn: t('columnMenuHideColumn'),
  columnMenuUnsort: t('columnMenuUnsort'),
  MuiTablePagination: {
    labelRowsPerPage: t('labelRowsPerPage'),
    labelDisplayedRows: ({ from, to, count }) => {
      return `${from} - ${to} ${t('labelDisplayedRows')} ${count}`;
    },
  },
  footerRowSelected: (count) => {
    return count + ' ' + t('footerRowSelected', { count });
  },
});
